<template>
  <div>
    <!-- 弹窗式开通会员模块 -->
    <div
      v-if="isPopup"
      class="isPopup-box"
      :style="`backgroundImage:url(${$utils.getPng('web4/isPopupbg')})`"
    >
      <div class="title-nav">
        <div
          class="user-img"
          :style="`backgroundImage:url(${$utils.getPng('web4/tuoyuan')})`"
        >
          <img
            class="avater avater2"
            :src="$store.state.userInfo.logo || $utils.getPng('user-nopic2')"
          />
        </div>
        <div class="Vip-nav-box">
          <div class="user-name-box">
            <div class="user-name">
              {{ $store.state.userInfo.nickname || "未登录" }}
            </div>
            <img
              style="height: 17px"
              v-if="$store.state.language == 'en'"
              v-show="
                $utils.getCookie($glb.fmCookieName) &&
                memberInfo?.tag?.length == 0
              "
              class="sign-icon"
              src="../../assets/img/free.png"
            />
            <img
              style="height: 17px"
              v-else-if="$store.state.language == 'hk'"
              v-show="
                $utils.getCookie($glb.fmCookieName) &&
                memberInfo?.tag?.length == 0
              "
              class="sign-icon"
              src="../../assets/img/free-hk.png"
            />
            <img
              class="sign-icon"
              style="width: 42px; height: 17px"
              v-else
              v-show="
                $utils.getCookie($glb.fmCookieName) &&
                memberInfo?.tag?.length == 0
              "
              src="../../assets/img/free-1.png"
            />
          </div>
          <div
            class="noVip"
            v-show="
              $utils.getCookie($glb.fmCookieName) &&
              memberInfo?.tag?.length == 0
            "
          >
            {{ $t("vip.openVip") }}
          </div>
        </div>
        <div class="user-vip">
          <div
            class="vip-box"
            v-for="(item, index) in memberInfo?.tag"
            :key="index"
            style="margin-right: 8px; font-size: 0"
          >
            <el-tooltip :content="item.label" placement="top">
              <img
                style="height: 16px"
                :src="
                  item.url.indexOf('icon-dcvip-light') > 0
                    ? $utils.getPng(`web4/icon-dcvip-${$store.state.theme}`)
                    : item.url
                "
                alt=""
              />
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="cen-box">
        <div class="left-box" v-if="memberInfo?.new_pay_list">
          <div class="left-title">
            {{ memberInfo?.new_pay_list[vipSelectType].subject_label }}
            <span
              v-html="
                $utils.getSearchKeyword(
                  memberInfo?.new_pay_list[vipSelectType].tag_num.label,
                  memberInfo?.new_pay_list[vipSelectType].tag_num.label_spec,
                  '#f67942',
                  0
                )
              "
            ></span>
          </div>
          <div
            :style="{
              marginLeft: $store.state.language == 'en' ? '7px' : '24px',
            }"
            class="left-for"
            v-for="(item, index) in memberInfo?.new_pay_list[vipSelectType]
              .tags"
            :key="index"
          >
            <img
              class="vip-icon"
              :src="
                removePngExtension(item.icon) +
                '_' +
                $store.state.theme +
                '.png'
              "
            />
            <div class="vip-info">
              <div class="vip-title">{{ item.title }}</div>
              <div class="vip-dai">{{ item.lable }}</div>
            </div>
          </div>
          <div class="left-btn" @click="allQuanFn">
            {{ $t("vip.ViewAllBenefits")
            }}<svg-btn
              style="width: 12px; height: 12px; margin-left: 4px"
              icon-class="icon_nextyh"
            />
          </div>
        </div>
        <div class="right-box" v-if="memberInfo?.new_pay_list">
          <div class="right-top">
            <div
              class="moveLeft"
              @click="scrollTo(0)"
              v-show="scrollButton.left"
            >
              <svg-btn
                style="width: 16px; height: 16px; color: #000"
                icon-class="icon-more-fmp"
              />
            </div>
            <div
              class="moveRight"
              @click="scrollTo(9999)"
              v-show="scrollButton.right"
            >
              <svg-btn
                style="width: 16px; height: 16px; color: #000"
                icon-class="icon-more-fmp"
              />
            </div>
            <div class="vip-type" ref="scrollBox" id="myDiv" @scroll="onScroll">
              <div
                :style="{
                  'background-image': `url(${$utils.getPng(
                    index == vipSelectType
                      ? 'web4/vipSelectpop1'
                      : $store.state.theme != 'dark'
                      ? 'web4/vipNoSelect'
                      : 'web4/vipNoSelect2'
                  )})`,
                  width: item.is_vip_up == 1 ? '140px' : '',
                }"
                class="vip-box"
                :class="index == vipSelectType ? 'vip-select' : ''"
                v-for="(item, index) in memberInfo?.new_pay_list"
                :key="index"
                @click="vipSelect(item, index)"
              >
                <div
                  class="vip-title-top"
                  v-if="item?.up_vip_info?.explain?.info && item?.tag1"
                >
                  {{ $t("vip.PremiumEscalation") }}
                </div>
                <div class="vip-title">{{ item.subject_label }}</div>
                <div class="vip-price">
                  <div class="span1">
                    {{ item.full_title_label.split("￥")?.[0] }}
                  </div>
                  <div class="span2">¥</div>
                  {{ getLabel(item, index) }}
                  <div class="span3">
                    {{ item.full_title_label.split(/￥[\d.]*/)[1] }}
                  </div>
                </div>
                <div
                  class="vip-Discount"
                  :style="{ textDecorationLine: item.tag3 ? 'none' : '' }"
                >
                  {{ item.tag3 || item.original_price_label || "" }}
                </div>

                <div
                  class="vip-limitText"
                  :class="
                    item.tag
                      ? item?.is_vip_up == 0
                        ? 'vip-limitType2'
                        : 'vip-limitType1'
                      : ''
                  "
                >
                  {{ item.tag }}
                </div>
              </div>
            </div>
            <div class="vip-text">
              {{ getExtra(memberInfo?.new_pay_list[vipSelectType]) }}
            </div>
          </div>
          <!-- 此处加上style="width: 145px",是因为加入了银行卡支付,导致弹窗宽度不够;max-width: 560px是防止支付方式过多超出 -->
          <div class="right-bottom">
            <div class="bottom-top">
              <div class="PaymentTools" style="max-width: 560px">
                <div
                  class="ToolsType"
                  style="width: 140px"
                  :class="index == ToolsSelectType ? 'ToolsSelect' : ''"
                  v-for="(item, index) in payData"
                  :key="index"
                  @click="ToolsSelect(index, item)"
                >
                  <img :src="item.icon" />
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="bottom-bottom">
              <div class="bottom-bottom-left">
                <div class="shifu-box">
                  <div class="span1">
                    {{ $t("vip.ActualPayment") }}：
                    <!-- 补差价升级 -->
                    <div
                      class="span4"
                      v-if="
                        memberInfo?.new_pay_list[vipSelectType]?.up_vip_info
                          ?.explain?.info &&
                        memberInfo?.new_pay_list[vipSelectType]?.tag1
                      "
                      @click="showUpgradeexplain = true"
                    >
                      {{ $t("vip.PremiumEscalation")
                      }}<svg-btn
                        style="width: 12px; height: 12px; margin-left: 2px"
                        icon-class="explain2"
                      />
                    </div>
                    <!-- 补差价升级 -->
                    <!-- 已优惠 -->
                    <div
                      class="span3"
                      v-if="
                        !memberInfo?.new_pay_list[vipSelectType]?.tag3 &&
                        memberInfo?.new_pay_list[vipSelectType]
                          ?.original_price_label &&
                        (memberInfo?.new_pay_list[vipSelectType]?.coupon ==
                          null ||
                          coupon_id == 0) &&
                        !isUseCoupon
                      "
                      :style="{
                        paddingRight:
                          $store.state.language == 'en' ? '6px' : '0',
                      }"
                    >
                      <span
                        v-show="
                          $store.state.language == 'cn' ||
                          $store.state.language == 'hk'
                        "
                        >{{ $t("vip.offAlready") }}</span
                      ><span
                        style="margin-right: -2px"
                        v-show="$store.state.language == 'en'"
                        >￥</span
                      ><span>{{
                        !isUseCoupon
                          ? parseInt(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.web_original_price
                            ) -
                            parseInt(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.real_price
                            )
                          : getPrice(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.real_price
                            )
                      }}</span
                      ><span
                        v-show="
                          $store.state.language == 'cn' ||
                          $store.state.language == 'hk'
                        "
                        >元！</span
                      ><span
                        style="margin-left: 4px"
                        v-show="$store.state.language == 'en'"
                        >{{ $t("vip.offAlready") }}</span
                      >
                    </div>
                    <!-- 已优惠 -->

                    <!-- 立减+优惠 -->
                    <div
                      class="span6"
                      :style="
                        $store.state.language == 'en'
                          ? { 'padding-right': '10px' }
                          : {}
                      "
                      v-if="
                        memberInfo?.new_pay_list[vipSelectType]?.coupon !=
                          null && coupon_id != 0
                      "
                    >
                      <div class="boxOne">
                        <svg-btn class="icon-quan" icon-class="icon-quan" />
                        {{ $t("vip.Discount") }}￥{{
                          memberInfo?.new_pay_list[vipSelectType]?.coupon.remit
                        }}
                        <span class="icon-xian"></span>
                      </div>
                      <div>
                        <span
                          v-show="
                            $store.state.language == 'cn' ||
                            $store.state.language == 'hk'
                          "
                          >{{ $t("vip.offAlready") }}</span
                        ><span
                          style="margin-right: -2px"
                          v-show="$store.state.language == 'en'"
                          >￥</span
                        ><span>{{
                          !isUseCoupon
                            ? parseInt(
                                memberInfo?.new_pay_list[vipSelectType]
                                  ?.web_original_price
                              ) -
                              parseInt(
                                memberInfo?.new_pay_list[vipSelectType]
                                  ?.real_price
                              ) +
                              parseInt(
                                memberInfo?.new_pay_list[vipSelectType]?.coupon
                                  .remit
                              )
                            : getPrice(
                                memberInfo?.new_pay_list[vipSelectType]
                                  ?.real_price
                              )
                        }}</span
                        ><span
                          v-show="
                            $store.state.language == 'cn' ||
                            $store.state.language == 'hk'
                          "
                          >元！</span
                        ><span
                          style="margin-left: 4px"
                          v-show="$store.state.language == 'en'"
                          >{{ $t("vip.offAlready") }}</span
                        >
                      </div>
                    </div>
                    <!-- 立减+优惠 -->
                    <!-- 优惠码享受多少折扣 -->
                    <div
                      class="span3"
                      v-if="
                        isUseCoupon &&
                        (memberInfo?.new_pay_list[vipSelectType]?.coupon ==
                          null ||
                          coupon_id == 0)
                      "
                    >
                      已享受{{ parseInt(couponDiscount * 100) / 10 }}折优惠
                    </div>
                    <!-- 优惠码享受多少折扣 -->
                  </div>
                </div>
                <div class="bottom-bottom-left-top">
                  <div class="span2">
                    <span style="margin-right: -5px">￥</span
                    >{{
                      !isUseCoupon
                        ? paymentAmount ?? paymentAmount
                        : getPrice(
                            memberInfo?.new_pay_list[vipSelectType]?.real_price
                          )
                    }}
                  </div>
                  <div
                    class="Renewalfee"
                    v-if="
                      memberInfo?.new_pay_list[vipSelectType]?.is_cycle == 1
                    "
                  >
                    {{ $t("vip.Renewalfee")
                    }}{{ memberInfo?.new_pay_list[vipSelectType]?.sub_price
                    }}<span
                      v-if="
                        $store.state.language == 'cn' ||
                        $store.state.language == 'hk'
                      "
                      >元</span
                    >
                  </div>
                </div>
                <div class="bottom-bottom-left-btn">
                  <fm-button
                    @click="handlerefreshFn(1)"
                    style="width: 264px; height: 52px"
                    >{{ $t("vip.OpenVIP") }}</fm-button
                  >
                </div>
                <div class="bottom-bottom-left-agreement">
                  <div class="agreement">
                    <div class="btn-svg">
                      <svg-btn
                        class="icon_checks"
                        @click="checkArchives"
                        :icon-class="
                          isChecked
                            ? 'icon-file-check'
                            : 'icon-file-uncheck-' + $store.state.theme
                        "
                      >
                      </svg-btn>
                    </div>
                    <span
                      >{{ $t("agreement.readAndAgree")
                      }}<a
                        :href="`${$glb.fmUrl}/askdetail/124`"
                        target="_blank"
                        >{{
                          memberInfo?.new_pay_list[vipSelectType]?.is_cycle == 1
                            ? $t("agreement.memberServiceAgreement2")
                            : $t("agreement.memberServiceAgreement")
                        }}</a
                      >
                      <font
                        v-if="
                          memberInfo?.new_pay_list[vipSelectType]?.is_cycle == 1
                        "
                        >{{ $t("agreement.and") }}</font
                      ><a
                        v-if="
                          memberInfo?.new_pay_list[vipSelectType]?.is_cycle == 1
                        "
                        class="sf3"
                        :href="`${$glb.fmUrl}/askdetail/128`"
                        target="_blank"
                        >{{
                          $t("agreement.automaticRenewalServiceAgreement")
                        }}</a
                      >
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="bottom-bottom-right"
                v-if="superSlideData?.length > 0"
              >
                <div
                  class="chakanquanyi"
                  v-show="
                    (memberInfo?.new_pay_list?.[vipSelectType]
                      ?.is_support_coupon == 1 ||
                      memberInfo?.new_pay_list?.[vipSelectType]
                        ?.is_can_used_wg_coupon == 1) &&
                    (SelectPid === 'alipay' ||
                      SelectPid === 'wxpay' ||
                      SelectPid === 'cardpay')
                  "
                  @click="useyh()"
                >
                  {{ $t("vip.Useode")
                  }}<svg-btn
                    style="width: 12px; height: 12px; margin-left: 4px"
                    icon-class="icon_nextyh"
                  />
                </div>
                <div class="swiper">
                  <div class="slide1"></div>
                  <div class="slide2"></div>
                  <SuperSlide
                    ref="SuperSlide"
                    :superSlideData="superSlideData"
                  ></SuperSlide>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 嵌入式会员开通模块 -->
    <div
      v-else
      v-loading="loading"
      element-loading-text="正在开通中，会员服务即将生效"
      class="PayOrderVip-box"
      :style="`backgroundImage:url(${$utils.getPng('web4/PayOrderVipbg2')})`"
    >
      <div class="title-nav">
        <div
          class="user-img"
          :style="`backgroundImage:url(${$utils.getPng('web4/tuoyuan')})`"
        >
          <img
            class="avater avater2"
            :src="$store.state.userInfo.logo || $utils.getPng('user-nopic2')"
          />
        </div>
        <div class="Vip-nav-box">
          <div class="user-name-box">
            <div class="user-name">
              {{ $store.state.userInfo.nickname || "未登录" }}
            </div>
            <img
              style="height: 17px"
              v-if="$store.state.language == 'en'"
              v-show="
                $utils.getCookie($glb.fmCookieName) &&
                memberInfo?.tag?.length == 0
              "
              class="sign-icon"
              src="../../assets/img/free.png"
            />
            <img
              style="height: 17px"
              v-else-if="$store.state.language == 'hk'"
              v-show="
                $utils.getCookie($glb.fmCookieName) &&
                memberInfo?.tag?.length == 0
              "
              class="sign-icon"
              src="../../assets/img/free-hk.png"
            />
            <img
              class="sign-icon"
              style="width: 42px; height: 17px"
              v-else
              v-show="
                $utils.getCookie($glb.fmCookieName) &&
                memberInfo?.tag?.length == 0
              "
              src="../../assets/img/free-1.png"
            />
          </div>
          <div
            class="noVip"
            v-show="
              $utils.getCookie($glb.fmCookieName) &&
              memberInfo?.tag?.length == 0
            "
          >
            {{ $t("vip.openVip") }}
          </div>
        </div>
        <div class="user-vip">
          <div
            class="vip-box"
            v-for="(item, index) in memberInfo?.tag"
            :key="index"
            style="margin-right: 8px; font-size: 0"
          >
            <el-tooltip :content="item.label" placement="top">
              <img
                style="height: 16px"
                :src="
                  item.url.indexOf('icon-dcvip-light') > 0
                    ? $utils.getPng(`web4/icon-dcvip-${$store.state.theme}`)
                    : item.url
                "
                alt=""
              />
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="cen-box-box">
        <div class="cen-box">
          <div class="left-box" v-if="memberInfo?.new_pay_list">
            <div class="left-title">
              {{ memberInfo?.new_pay_list[vipSelectType].subject_label }}
              <span
                v-html="
                  $utils.getSearchKeyword(
                    memberInfo?.new_pay_list[vipSelectType].tag_num.label,
                    memberInfo?.new_pay_list[vipSelectType].tag_num.label_spec,
                    '#f67942',
                    0
                  )
                "
              ></span>
            </div>
            <div
              class="left-for"
              v-for="(item, index) in memberInfo?.new_pay_list[vipSelectType]
                .tags"
              :key="index"
            >
              <img
                class="vip-icon"
                :src="
                  removePngExtension(item.icon) +
                  '_' +
                  $store.state.theme +
                  '.png'
                "
              />
              <div class="vip-info">
                <div class="vip-title">{{ item.title }}</div>
                <div class="vip-dai">{{ item.lable }}</div>
              </div>
            </div>
            <div class="left-btn" @click="allQuanFn">
              {{ $t("vip.ViewAllBenefits")
              }}<svg-btn
                style="width: 12px; height: 12px; margin-left: 4px"
                icon-class="icon_nextyh"
              />
            </div>
          </div>
          <div class="right-box" v-if="memberInfo?.new_pay_list">
            <div class="right-top">
              <div class="scroll-box" style="margin-top: 14px">
                <div
                  v-show="scrollButton.left"
                  class="scroll-button"
                  @click="scrollTo(0)"
                >
                  <svg-btn icon-class="icon-arrow-up" />
                </div>
                <div class="vip-type" ref="scrollBox" @scroll="onScroll">
                  <div
                    :style="{
                      'background-image': `url(${$utils.getPng(
                        index == vipSelectType
                          ? 'web4/vipSelect'
                          : $store.state.theme != 'dark'
                          ? 'web4/vipNoSelect'
                          : 'web4/vipNoSelect2'
                      )})`,
                      width: item.is_vip_up == 1 ? '160px' : '',
                    }"
                    class="vip-box"
                    :class="index == vipSelectType ? 'vip-select' : ''"
                    v-for="(item, index) in memberInfo?.new_pay_list"
                    :key="index"
                    ref="vipList"
                    @click="vipSelect(item, index)"
                  >
                    <div
                      class="vip-title-top"
                      v-if="item?.up_vip_info?.explain?.info && item?.tag1"
                    >
                      {{ $t("vip.PremiumEscalation") }}
                    </div>
                    <div class="vip-title">{{ item.subject_label }}</div>
                    <div class="vip-price">
                      <div class="span1">
                        {{ item.full_title_label.split("￥")?.[0] }}
                      </div>
                      <div class="span2">¥</div>
                      {{ getLabel(item, index) }}
                      <div class="span3">
                        {{ item.full_title_label.split(/￥[\d.]*/)[1] }}
                      </div>
                    </div>
                    <div
                      class="vip-Discount"
                      :style="{ textDecorationLine: item.tag3 ? 'none' : '' }"
                    >
                      {{ item.tag3 || item.original_price_label || "" }}
                    </div>

                    <div
                      class="vip-limitText"
                      :class="
                        item.tag
                          ? item?.is_vip_up == 0
                            ? 'vip-limitType2'
                            : 'vip-limitType1'
                          : ''
                      "
                    >
                      {{ item.tag }}
                    </div>
                  </div>
                </div>
                <div
                  v-show="scrollButton.right"
                  class="scroll-button"
                  style="right: 0; transform: rotate(180deg)"
                  @click="scrollTo(9999)"
                >
                  <svg-btn icon-class="icon-arrow-up" />
                </div>
              </div>
              <div class="vip-text">
                {{ getExtra(memberInfo?.new_pay_list[vipSelectType]) }}
              </div>
            </div>
            <div class="right-bottom">
              <div class="bottom-top">
                <div class="PaymentTools" style="max-width: 790px">
                  <div
                    class="ToolsType"
                    :class="index == ToolsSelectType ? 'ToolsSelect' : ''"
                    v-for="(item, index) in payData"
                    :key="index"
                    @click="ToolsSelect(index, item)"
                  >
                    <img :src="item.icon" />
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <div
                  class="chakanquanyi"
                  v-show="
                    (memberInfo?.new_pay_list?.[vipSelectType]
                      ?.is_support_coupon == 1 ||
                      memberInfo?.new_pay_list?.[vipSelectType]
                        ?.is_can_used_wg_coupon == 1) &&
                    (SelectPid === 'alipay' ||
                      SelectPid === 'wxpay' ||
                      SelectPid === 'cardpay')
                  "
                  @click="useyh()"
                >
                  {{ $t("vip.Useode")
                  }}<svg-btn
                    style="width: 12px; height: 12px; margin-left: 4px"
                    icon-class="icon_nextyh"
                  />
                </div>
              </div>
              <div class="bottom-bottom">
                <div class="bottom-bottom-left">
                  <div class="span1">
                    {{ $t("vip.ActualPayment") }}:
                    <!-- 补差价升级 -->
                    <div
                      class="span5"
                      v-if="
                        memberInfo?.new_pay_list[vipSelectType]?.up_vip_info
                          ?.explain?.info &&
                        memberInfo?.new_pay_list[vipSelectType]?.tag1
                      "
                      @click="showUpgradeexplain = true"
                    >
                      {{ $t("vip.PremiumEscalation")
                      }}<svg-btn
                        style="width: 12px; height: 12px; margin-left: 2px"
                        icon-class="explain2"
                      />
                    </div>
                    <!-- 补差价升级 -->

                    <!-- 已优惠 -->
                    <div
                      class="span3"
                      v-if="
                        !memberInfo?.new_pay_list[vipSelectType]?.tag3 &&
                        memberInfo?.new_pay_list[vipSelectType]
                          ?.original_price_label &&
                        (memberInfo?.new_pay_list[vipSelectType]?.coupon ==
                          null ||
                          coupon_id == 0) &&
                        !isUseCoupon
                      "
                      :style="{
                        paddingRight:
                          $store.state.language == 'en' ? '6px' : '0',
                      }"
                    >
                      <span
                        v-show="
                          $store.state.language == 'cn' ||
                          $store.state.language == 'hk'
                        "
                        >{{ $t("vip.offAlready") }}</span
                      ><span
                        style="margin-right: -2px"
                        v-show="$store.state.language == 'en'"
                        >￥</span
                      ><span>{{
                        !isUseCoupon
                          ? parseInt(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.web_original_price
                            ) -
                            parseInt(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.real_price
                            )
                          : getPrice(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.real_price
                            )
                      }}</span
                      ><span
                        v-show="
                          $store.state.language == 'cn' ||
                          $store.state.language == 'hk'
                        "
                        >元！</span
                      ><span
                        style="margin-left: 4px"
                        v-show="$store.state.language == 'en'"
                        >{{ $t("vip.offAlready") }}</span
                      >
                    </div>
                    <!-- 已优惠 -->

                    <!-- 立减+优惠 -->
                    <div
                      class="span6"
                      :style="
                        $store.state.language == 'en'
                          ? { 'padding-right': '10px' }
                          : {}
                      "
                      v-if="
                        memberInfo?.new_pay_list[vipSelectType]?.coupon !=
                          null && coupon_id != 0
                      "
                    >
                      <div class="boxOne">
                        <svg-btn class="icon-quan" icon-class="icon-quan" />
                        {{ $t("vip.Discount") }}￥{{
                          memberInfo?.new_pay_list[vipSelectType]?.coupon.remit
                        }}
                        <span class="icon-xian"></span>
                      </div>
                      <div>
                        <span
                          v-show="
                            $store.state.language == 'cn' ||
                            $store.state.language == 'hk'
                          "
                          >{{ $t("vip.offAlready") }}</span
                        ><span
                          style="margin-right: -2px"
                          v-show="$store.state.language == 'en'"
                          >￥</span
                        ><span>{{
                          !isUseCoupon
                            ? parseInt(
                                memberInfo?.new_pay_list[vipSelectType]
                                  ?.web_original_price
                              ) -
                              parseInt(
                                memberInfo?.new_pay_list[vipSelectType]
                                  ?.real_price
                              ) +
                              parseInt(
                                memberInfo?.new_pay_list[vipSelectType]?.coupon
                                  .remit
                              )
                            : getPrice(
                                memberInfo?.new_pay_list[vipSelectType]
                                  ?.real_price
                              )
                        }}</span
                        ><span
                          v-show="
                            $store.state.language == 'cn' ||
                            $store.state.language == 'hk'
                          "
                          >元！</span
                        ><span
                          style="margin-left: 4px"
                          v-show="$store.state.language == 'en'"
                          >{{ $t("vip.offAlready") }}</span
                        >
                      </div>
                    </div>
                    <!-- 立减+优惠 -->

                    <!-- 优惠码享受多少折扣 -->
                    <div
                      class="span3"
                      v-if="
                        isUseCoupon &&
                        (memberInfo?.new_pay_list[vipSelectType]?.coupon ==
                          null ||
                          coupon_id == 0)
                      "
                    >
                      已享受{{ parseInt(couponDiscount * 100) / 10 }}折优惠
                    </div>
                    <!-- 优惠码享受多少折扣 -->
                  </div>
                  <div class="bottom-bottom-left-top">
                    <div class="span2">
                      <span style="margin-right: -5px">￥</span
                      >{{
                        !isUseCoupon
                          ? paymentAmount ?? paymentAmount
                          : getPrice(
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.real_price
                            )
                      }}
                    </div>
                    <div
                      class="Renewalfee"
                      v-if="
                        memberInfo?.new_pay_list[vipSelectType]?.is_cycle == 1
                      "
                    >
                      {{ $t("vip.Renewalfee")
                      }}{{ memberInfo?.new_pay_list[vipSelectType]?.sub_price
                      }}<span
                        v-if="
                          $store.state.language == 'cn' ||
                          $store.state.language == 'hk'
                        "
                        >元</span
                      >
                    </div>
                    <div class="bottom-bottom-left-agreement">
                      <div class="agreement">
                        <div class="btn-svg">
                          <svg-btn
                            class="icon_checks"
                            @click="checkArchives"
                            :icon-class="
                              isChecked
                                ? 'icon-file-check'
                                : 'icon-file-uncheck-' + $store.state.theme
                            "
                          >
                          </svg-btn>
                        </div>
                        <span
                          >{{ $t("agreement.readAndAgree")
                          }}<a
                            :href="`${$glb.fmUrl}/askdetail/124`"
                            target="_blank"
                            >{{
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.is_cycle == 1
                                ? $t("agreement.memberServiceAgreement2")
                                : $t("agreement.memberServiceAgreement")
                            }}</a
                          >
                          <font
                            v-if="
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.is_cycle == 1
                            "
                            >{{ $t("agreement.and") }}</font
                          ><a
                            v-if="
                              memberInfo?.new_pay_list[vipSelectType]
                                ?.is_cycle == 1
                            "
                            class="sf3"
                            :href="`${$glb.fmUrl}/askdetail/128`"
                            target="_blank"
                            >{{
                              $t("agreement.automaticRenewalServiceAgreement")
                            }}</a
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-bottom-left-btn">
                    <fm-button
                      @click="handlerefreshFn(1)"
                      style="width: 298px; height: 64px"
                      >{{ $t("vip.OpenVIP") }}</fm-button
                    >
                  </div>
                </div>
                <div
                  class="bottom-bottom-right"
                  v-if="superSlideData?.length > 0"
                >
                  <div class="swiper">
                    <div class="slide1"></div>
                    <div class="slide2"></div>
                    <SuperSlide
                      ref="SuperSlide"
                      :superSlideData="superSlideData"
                    ></SuperSlide>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 优惠码 -->
    <DiscountCodeBox
      ref="DiscountCodeBox"
      :isShow="showDiscountCode"
      :couponsId="coupon_id"
      :couponsList="couponsList"
      :supportCoupon="
        memberInfo?.new_pay_list?.[vipSelectType]?.is_support_coupon
      "
      :canusedwgcoupon="
        memberInfo?.new_pay_list?.[vipSelectType]?.is_can_used_wg_coupon
      "
      @handleClose="showDiscountCode = false"
      @checkCoupon="checkCoupon"
      @checkCoupe="couponValidate"
    ></DiscountCodeBox>
    <!-- 补差价升级说明 -->
    <Upgradeexplain
      ref="Upgradeexplain"
      :isShow="showUpgradeexplain"
      :upvipinfo="memberInfo?.new_pay_list?.[vipSelectType]?.up_vip_info"
      @handleClose="showUpgradeexplain = false"
    ></Upgradeexplain>
    <!-- 收银台 -->
    <PayCashier
      ref="PayCashierRef"
      :isShow="showPayCashier"
      :orderInfo="orderInfo"
      @handleClose="showPayCashier = false"
      @handlerefresh="handlerefreshFn"
      @openSuccess="openSuccessFn"
    ></PayCashier>
    <!-- 银行卡支付弹窗 -->
    <PayPal
      ref="PayPalRef"
      :isShow="showPayPal"
      :cardPayList="cardPayList"
      :dpayment="dpaymentStr"
      :payids="payids"
      @handleClose="showPayPal = false"
      @PaySignAPI="handlerefreshFn"
      @openSuccess="openSuccessFn"
    ></PayPal>
    <!-- 开通会员成功弹窗 -->
    <SuccessfullyModel
      :payToast="payToast"
      :isShowModel="showSuccessfullyModel"
      @successRefresh="successRefreshFn"
    ></SuccessfullyModel>
  </div>
</template>

<script>
import flowers from "@/utils/animation/flowers";
import lottie from "lottie-web";
import {
  getBuyListAPI,
  payMemberListSimpleAPI,
  couponValidateAPi,
  generatePaySignAPI,
  getSpecStatusAPI,
} from "@/utils/apiList/vip.js";
import SuperSlide from "../Member/SuperSlide.vue";
import Upgradeexplain from "../Member/Upgradeexplain.vue";
import DiscountCodeBox from "../Member/DiscountCodeBox.vue";
import PayCashier from "../Member/PayCashier.vue";
import PayPal from "../Member/PayPal.vue";
import SuccessfullyModel from "../Member/SuccessfullyModel.vue";
// import { init,createElement } from '@airwallex/components-sdk';
// import { loadStripe } from '@stripe/stripe-js';
export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SuperSlide,
    Upgradeexplain,
    DiscountCodeBox,
    PayCashier,
    SuccessfullyModel,
    PayPal,
  },
  data() {
    return {
      dpaymentStr: "",
      payids: "",
      upvipinfo: {},
      memberInfo: {},
      showUpgradeexplain: false, // 补差价升级说明弹窗
      showDiscountCode: false,
      showPayCashier: false,
      showSuccessfullyModel: false,
      vipSelectType: 0,
      ToolsSelectType: 0,
      SelectPid: "alipay",
      superSlideData: [],
      isChecked: true,
      vipList: [],
      scrollButton: {
        left: false,
        right: true,
      },
      payData: [
        {
          pid: "alipay",
          name: "支付宝",
          icon: this.$utils.getPng("icon_pay_23"),
        },
        {
          pid: "huabei",
          name: "花呗免息分期",
          icon: this.$utils.getPng("icon_pay_33"),
        },
        {
          pid: "wxpay",
          name: "微信支付",
          icon: this.$utils.getPng("icon_pay_2_11"),
        },
      ],
      route_ids: [],
      voucher: "",
      is_pc: 0,
      payToast: {
        vlist: [],
      },
      animation: "",
      couponDiscount: 1,
      isUseCoupon: false,
      coupndataLast: {},
      myDivleft: 10,
      resultArray: [],
      coupon_id: "",
      couponsList: [], //代金券信息
      cash_id: 1,
      idList: [],
      pay_id: "",
      authCode: "",
      authState: "",
      paymentAmount: "",
      isStatus: 1,
      loading: false,
      showPayPal: false,
      cardPayList: {}, //银行卡所用参数
      payment_intent_status: 1,
      stripe: null,
    };
  },
  created() {
    this.route_ids = this.$store.state.route_ids.join("-");
    this.voucher = this.$store.state.voucher;
    this.is_pc = this.$store.state.is_pc;
    if (this.voucher == "" && this.route_ids == "A1") {
      this.$utils.routeModeReported("B13");
      this.route_ids = this.$store.state.route_ids.join("-");
    }

    this.getBuyList();
    this.getPcMember();
    if (this.$utils.getCookie(this.$glb.fmCookieName) == null) {
      this.$store.commit("clearUserData"); //重置缓存
    }
    if (this.$route.query?.authCode) {
      this.loading = true;
      this.authCode = this.$route.query?.authCode;
      this.authState = this.$route.query?.authState;
      this.payTimer = setInterval(() => {
        this.getOrderStatus(this.authCode, this.authState);
      }, 4000);
      this.$router.push({
        path: this.$route.path,
      });
    }
    //从扩充下线模式过来的就直接走这套逻辑
    const expand = sessionStorage.getItem("expand");
    if (expand) {
      this.$store.commit("setAttr", {
        name: "route_ids",
        val: ["A1", "B35", expand],
      });
      this.route_ids = this.$store.state.route_ids.join("-");
      // 立即清除标记，避免其他跳转误触发
      // sessionStorage.removeItem('expand');
      // sessionStorage.removeItem('rebate_model');
    }
  },
  destroyed() {
    sessionStorage.removeItem("expand");
  },
  watch: {
    coupon_id() {
      this.findAmount();
    },
  },
  mounted() {
    // this.initCard()
  },
  computed: {
    bankStyle() {
      return {
        base: {
          color:
            this.$store.state.theme === "light"
              ? "#2c2c2c"
              : "rgba(255,255,255,0.9)",
          fontSize: "14px",
          "::placeholder": {
            color: "#bdbdbe",
          },
          iconColor: "transparent",
          "::icon": {
            display: "none",
          },
        },
        showIcon: false,
        invalid: {
          color: "#f53f3f",
          iconColor: "#f53f3f",
        },
      };
    },
  },
  methods: {
    //创建airwallex实例
    async initCard() {
      const env = this.payment_intent_status === 0 ? "demo" : "prod";
      // console.log('当前支付环境',env)
      // 1. 初始化 SDK
      // if (window.AirwallexSDK) {
      //   console.log('[Airwallex] 复用已有实例');
      //   return;
      // }
      try {
        // const airwallex = await init({
        //   env: env,//'staging | 'demo' | 'prod'
        //   enabledElements: ['payments'],// 'payments 其他支付方式（如支付宝、微信等）' | 'card 信用卡支付'
        //   origin: window.location.origin,
        //   locale: 'zh',
        // })
        // this.stripe = await Stripe('pk_test_51OkliHKckghudUoiMJ3etZBJWWeII1cNaKqg05dBuqURkQQiwHioB7qqEbaQx2iSq7W4LrdIc7xs2KOvvZlySTFS00U6xv5oGF');
        // console.log('stripe',this.stripe)
        // // 创建独立的 Elements
        // const elements = this.stripe.elements();
        // console.log('elements',elements)

        // const substance= {
        //     cardNumber: await elements.create('cardNumber'),
        //     expiry: await elements.create('cardExpiry'),
        //     cvc: await elements.create('cardCvc'),
        // }
        // 存入全局对象
        // window.AirwallexSDK = {
        //   env,
        //   elements,
        //   substance,
        //   isReady: true
        // }
        // console.log("[Airwallex] 预加载完成");
      } catch (error) {
        // console.error("Airwallex SDK 初始化失败:", error);
        // window.AirwallexSDK = { error: true }
      }
    },
    //获取会员套餐价格
    getLabel(item, loopIndex) {
      let result;
      if (item.coupon) {
        if (loopIndex === this.vipSelectType) {
          if (this.coupon_id === item.coupon.id) {
            result = item.coupon.title_price_label;
          } else {
            result = item.title_price_label;
          }
        } else {
          result = item.coupon.title_price_label;
        }
      } else {
        result = item.title_price_label;
      }
      return result;
    },
    //获取会员套餐描述
    getExtra(item) {
      let result;
      if (item.coupon) {
        if (this.coupon_id === item.coupon.id) {
          result = item.coupon.extra_label;
        } else {
          result = item.extra_label;
        }
      } else {
        result = item.extra_label;
      }
      return result;
    },
    //计算实付金额
    findAmount() {
      const selectedPayInfo = this.memberInfo.new_pay_list[this.vipSelectType];
      // 不使用优惠券的情况
      if (this.coupon_id == 0 || this.coupon_id == "") {
        this.paymentAmount = selectedPayInfo ? selectedPayInfo.real_price : 0;
      } else {
        if (selectedPayInfo && selectedPayInfo.coupon !== null) {
          let amount = (
            (Number(selectedPayInfo.real_price) * 100 -
              Number(selectedPayInfo.coupon.remit) * 100) /
            100
          ).toFixed(2);
          let numAmount = Number(amount);
          if (numAmount === Math.floor(numAmount)) {
            this.paymentAmount = numAmount;
          } else {
            this.paymentAmount = amount.replace(/(\.\d*)?0+$/, "$1");
          }
        }
      }
    },
    removePngExtension(url) {
      // 使用正则表达式替换 .png
      return url.replace(/\.png$/, "");
    },
    moveRightFn() {
      var div = document.getElementById("myDiv");
      var left = 0;
      left = -280; //
      this.myDivleft = left;
      div.style.left = left + "px";
    },
    moveLeftFn() {
      var div = document.getElementById("myDiv");
      var left = 0;
      left = 10;
      this.myDivleft = left;
      div.style.left = left + "px";
    },
    allQuanFn() {
      this.$emit("allQuan");
    },
    getPrice(price) {
      let amount = (price * this.couponDiscount).toFixed(2);
      let numAmount = Number(amount);
      let payPrice;
      if (numAmount === Math.floor(numAmount)) {
        payPrice = numAmount;
      } else {
        payPrice = amount.replace(/(\.\d*)?0+$/, "$1");
      }
      return payPrice;
    },
    successRefreshFn() {
      this.showSuccessfullyModel = false;
      this.isUseCoupon = false;
      this.$emit("SuccessClose");
      this.animation = "";
      lottie.stop();
      lottie.destroy();
      this.getPcMember();
      this.getBuyList();
    },
    openSuccessFn(item) {
      this.coupon_id = "";
      this.showPayPal = false;
      this.showPayCashier = false;
      this.payToast = item;
      this.showSuccessfullyModel = true;
      this.$nextTick(() => {
        var lottieElement = document.getElementById("lottie");
        if (lottieElement) {
          document.getElementById("lottie").innerHTML = "";
        }
        this.animation = lottie.loadAnimation({
          container: document.getElementById("lottie"), // Required
          animationData: flowers,
          renderer: "svg", // Required
          loop: false, // Optional
          autoplay: true, // Optional
        });
      });
      this.getPcMember();
    },
    handlerefreshFn: _.debounce(
      function (item) {
        if (this.$utils.getCookie(this.$glb.fmCookieName) == null) {
          this.goLogin();
          return;
        }

        this.newPay(item, this.coupndataLast);
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    goLogin() {
      let path = this.$route.fullPath.toString().slice(1);
      this.$router.push({ path: "/login", query: { path: path } });
      return;
    },
    newPay(type, coupndata = {}) {
      if (!this.isChecked) {
        this.$toast("请勾选协议后再支付", 4);
        return;
      }

      const switchs =
        this.$store.state.userInfo.switchs.path_official_channel_switch == 0 &&
        this.$store.state.userInfo.switchs.path_daren_channel_switch == 0;
      const requestId = Date.now();
      this.currentRequestId = requestId; //接口返回时间不一致差别较大 获取当前请求时间 一致时再生成二维码（防止月度会员微信支付接口返回需要594ms 连续包月300ms 快速切换时 切换到连续包月后 但是微信支付接口反应慢会覆盖连续包月的二维码）

      let vipList = this.$store.state.userInfo.vips;
      if (this.payData[this.ToolsSelectType].pid == "cardpay") {
        if (this.memberInfo?.new_pay_list[this.vipSelectType]?.invalid_pay_toast) {
          this.$toast(this.memberInfo?.new_pay_list[this.vipSelectType]?.invalid_pay_toast, 4);
          return;
        }
      }

      if (this.payData[this.ToolsSelectType].pid == "cardpay" && type != 4) {
        this.cardPayList = {
          new_real_price: !this.isUseCoupon
            ? this.paymentAmount
            : this.getPrice(
                this.memberInfo?.new_pay_list[this.vipSelectType]?.real_price
              ),
        };
        this.showPayPal = true;
        return;
      }

      if (type == 3) {
        generatePaySignAPI({
          pay_id: this.memberInfo.new_pay_list[this.vipSelectType].pay_id,
          pay_type: this.payData[this.ToolsSelectType].pid,
          coupon: coupndata.coupon ? coupndata.coupon : "",
          voucher: this.voucher,
          page_num_list: switchs ? "" : this.route_ids,
          coupon_user_id: this.coupon_id != 0 ? this.coupon_id : "",
          is_pc: this.is_pc,
          scene: "wap",
          new_pay_channel: this.payData[this.ToolsSelectType].key || "",
        })
          .then((res) => {
            if (res.status == 1) {
              const newWindow = window.open("", "_blank");
              newWindow.document.write(res.data.shtml);
            } else if (res.status == 50013) {
              this.$toast(res.msg, 2);
            } else if (res.status == 0) {
              this.$refs.PayPalRef.Payloading();
              this.$toast(res.msg, 4);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        return;
      }
      this.payids = this.memberInfo.new_pay_list[this.vipSelectType].pay_id;
      generatePaySignAPI({
        pay_id: this.memberInfo.new_pay_list[this.vipSelectType].pay_id,
        pay_type: this.payData[this.ToolsSelectType].pid,
        coupon: coupndata.coupon ? coupndata.coupon : "",
        voucher: this.voucher,
        page_num_list: switchs ? "" : this.route_ids,
        coupon_user_id: this.coupon_id != 0 ? this.coupon_id : "",
        is_pc: this.is_pc,
        route: this.$route.fullPath,
        new_pay_channel: this.payData[this.ToolsSelectType].key || "",
      })
        .then((res) => {
          if (res.status == 1) {
            //银行卡支付

            if (this.payData[this.ToolsSelectType].pid == "cardpay") {
              this.cardPayList = {
                pay_id: this.memberInfo.new_pay_list[this.vipSelectType].pay_id,
                pay_type: this.payData[this.ToolsSelectType].pid,
                coupon: coupndata.coupon ? coupndata.coupon : "",
                voucher: this.voucher,
                page_num_list: switchs ? "" : this.route_ids,
                coupon_user_id: this.coupon_id != 0 ? this.coupon_id : "",
                is_pc: this.is_pc,
                route: this.$route.fullPath,
                new_real_price: !this.isUseCoupon
                  ? this.paymentAmount
                  : this.getPrice(
                      this.memberInfo?.new_pay_list[this.vipSelectType]
                        ?.real_price
                    ),
              };
              this.showPayPal = true;
              this.dpaymentStr = res.data;
              return;
            }

            if (
              res.data.open_type &&
              res.data.open_type == 1 &&
              this.isStatus == 1
            ) {
              window.open(res.data.qrcode, "_blank");
              return;
            }
            this.orderInfo = {
              ...res.data,
              pay_id: this.memberInfo.new_pay_list[this.vipSelectType].pay_id,
              new_real_price: !this.isUseCoupon
                ? this.paymentAmount
                : this.getPrice(
                    this.memberInfo?.new_pay_list[this.vipSelectType]
                      ?.real_price
                  ),
            };
            if (this.payData[this.ToolsSelectType]?.prompt) {
              this.orderInfo.prompt =
                this.payData[this.ToolsSelectType]?.prompt;
            }
            if (this.currentRequestId == requestId) {
              if (type == 1) {
                this.showPayCashier = true;
              } else if (type == 2) {
                this.$refs.PayCashierRef.createCode(this.orderInfo);
              }
            }
            if (this.coupon_id != 0 && res.data.coupon_msg != null) {
              this.$toast(res.data.coupon_msg, 4);
            }
          } else if (res.status == 50013) {
            this.$toast(res.msg, 2);
          } else if (res.status == 0) {
            this.$refs.PayPalRef.Payloading();
            this.$toast(res.msg, 4);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOrderStatus(authCode, authState) {
      let data = {
        auth_code: authCode,
        auth_state: authState,
      };
      getSpecStatusAPI(data)
        .then((res) => {
          if (res.status == 1) {
            this.loading = false;
            this.$emit("closeLoading");
            this.openSuccessFn(res.data.pay_toast);
            clearInterval(this.payTimer);
          }
          if (res.status == 2) {
            this.loading = false;
            this.$emit("closeLoading");
            clearInterval(this.payTimer);
          }
          if (res.status == 3) {
            this.loading = false;
            this.$emit("closeLoading");
            this.$toast(res.msg, 2);
            clearInterval(this.payTimer);
          }
          if (res.status == 1012) {
            this.loading = false;
            this.$emit("closeLoading");
            clearInterval(this.payTimer);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$emit("closeLoading");
        });
    },
    closeLoading() {
      this.$emit("closeLoading");
    },
    couponValidate: _.debounce(
      function (item) {
        if (
          this.memberInfo?.new_pay_list[this.vipSelectType]?.up_vip_info
            ?.explain?.info &&
          this.memberInfo?.new_pay_list[this.vipSelectType]?.tag1
        ) {
          if (
            this.memberInfo?.new_pay_list[this.vipSelectType]?.up_vip_info
              ?.preferential != 1
          ) {
            this.isUseCoupon = false;
            return;
          }
        }
        couponValidateAPi({
          coupon: item,
          pay_id: this.memberInfo?.new_pay_list[this.vipSelectType]?.pay_id,
        })
          .then((res) => {
            if (res.status == 1) {
              this.$toast(
                `使用当前优惠码购买，享受${res.data.discount_label}折优惠`,
                1
              );
              this.couponDiscount = res.data.discount;
              this.coupndataLast = {
                coupon: this.$refs.DiscountCodeBox.coupeValue,
                discount: res.data.discount,
              }; //将本次带的优惠码存储在coupndataLast,切换套餐时需要保留优惠只有在切换套餐至连续包月和花呗时清空coupndataLast
              if (res.data.discount) {
                this.isUseCoupon = true;
                this.couponDiscount = res.data.discount;
              } else {
                this.isUseCoupon = false;
                this.couponDiscount = 1;
              }
              // this.newPay(1, {
              //   coupon: this.$refs.DiscountCodeBox.coupeValue,
              //   discount: res.data.discount,
              // });
              this.showDiscountCode = false;
            } else {
              this.$toast(res.msg, 2);
              this.$refs.DiscountCodeBox.coupeValue = "";
              this.coupndataLast = {};
              this.showDiscountCode = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      100,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    getPcMember(obj = {}, type = 0) {
      payMemberListSimpleAPI(obj)
        .then((res) => {
          if (res.status == 1) {
            this.resultArray = [];

            res.data.new_pay_list[this.vipSelectType].payment_channel.forEach(
              (item, index) => {
                if (
                  item.key != "4" &&
                  item.key != "7" &&
                  item.key != "8" &&
                  item.value == "1"
                ) {
                  this.resultArray.push(item); // 添加数字 1
                }
              }
            );
            this.$store.commit("setAttr", {
              name: "memberBenefitsImg",
              val: res.data.member_benefits_img,
            });

            // this.memberInfo = res.data;

            if (obj?.select_vip_id) {
              res.data.new_pay_list.forEach((item, index) => {
                if (item.pay_id == obj.select_vip_id) {
                  this.memberInfo.new_pay_list[index] = item;
                }
              });
            } else {
              this.memberInfo = res.data;
            }

            this.payDataFn();
            if(type == 1) {
              this.handlerefreshFn(1)
            }

            // this.$nextTick(() => {
            //   if(this.$refs.scrollBox) this.scrollButton.right = this.$refs.scrollBox.scrollWidth > this.$refs.scrollBox.clientWidth
            // })

            this.upvipinfo = res.data.up_vip_info || [];
            this.couponsList = res.data.new_coupons || [];
            this.payment_intent_status = Number(res.data.payment_intent_status);
            //获取默认选中第一个的值
            if (
              !obj?.defaultchek &&
              this.memberInfo.new_pay_list[this.vipSelectType]?.coupon != null
            ) {
              this.coupon_id =
                this.memberInfo.new_pay_list[this.vipSelectType]?.coupon.id;
            } else if (obj?.defaultchek) {
              this.coupon_id = 0;
            }

            this.pay_id =
              this.memberInfo.new_pay_list[this.vipSelectType]?.pay_id;
            if (this.couponsList.length > 0) {
              let arr = [];
              this.couponsList.forEach((item) => {
                const vipIds = item.vip_ids?.split(",") ?? []; // 分割成数组
                arr.push(...vipIds);
              });
              this.idList = [...new Set(arr)];
              this.checkCash();
            }
            this.findAmount();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //选择代金券点击确认
    checkCoupon(row, checkitem) {
      //执行关闭弹窗逻辑
      if (row == "empty") {
        this.coupon_id = "";
        this.showDiscountCode = false;
        return;
      }
      if (row == "coupeValue") {
        this.coupon_id = "";
      }
      if (row == "coupeValue" && this.couponsList.length > 0) {
        //如果选择的是优惠码
        //判断下拉框内有没有id为0的选项
        const hasIdZero = this.couponsList.some((item) => item.id === 0);
        if (hasIdZero) {
          this.coupon_id = 0;
        } else {
          this.coupon_id = "";
        }
      } else {
        //如果选择的是代金券
        this.coupndataLast = {};
        this.isUseCoupon = false;
        this.couponDiscount = 1;
        if (row != this.coupon_id) {
          const payId =
            this.memberInfo.new_pay_list[this.vipSelectType]?.pay_id;
          if (row == 0) {
            this.getPcMember({
              select_vip_id: payId,
              coupon_id: checkitem?.coupon_id || 999,
              defaultchek: true,
            });
          } else {
            this.getPcMember({
              select_vip_id: payId,
              coupon_id: checkitem?.coupon_id || 999,
            });
          }
        }
      }
      this.showDiscountCode = false;
    },
    //操作代金券数组
    checkCash() {
      if (this.idList.includes(this.pay_id)) {
        this.couponsList.forEach((item) => {
          if (
            item.id == this.coupon_id ||
            item.vip_ids?.split(",").map(Number).includes(+this.pay_id) ||
            item.id == 0
          ) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        });
        //后端说id不会返回0，则不使用赋值id为0
        //先检查是否已经存在id为0的元素
        const hasIdZero = this.couponsList.some((item) => item.id === 0);
        if (!hasIdZero) {
          this.couponsList.push({ id: 0, title: "不使用", disabled: false });
        }
        //如何选择了能使用的会员套餐且选择的是不使用，则把coupon_id变为0
        if (this.memberInfo.new_pay_list[this.vipSelectType]?.coupon == null) {
          this.coupon_id = 0;
        }
      } else {
        this.coupon_id = "";
        this.couponsList = this.couponsList.reduce((acc, item) => {
          if (item.id != 0) {
            item.disabled = true;
            acc.push(item);
          }
          return acc;
        }, []);
      }
    },
    payDataFn(type) {
      this.payData = [];
      this.resultArray.forEach((item) => {
        if (item.key == 1) {
          this.payData.push({
            pid: "alipay",
            name: "支付宝",
            icon: this.$utils.getPng("icon_pay_23"),
            key: item.key,
          });
        } else if (item.key == 2) {
          this.payData.push({
            pid: "huabei",
            name: "花呗免息分期",
            icon: this.$utils.getPng("icon_pay_33"),
            key: item.key,
          });
        } else if (item.key == 3) {
          this.payData.push({
            pid: "wxpay",
            name: "微信支付",
            icon: this.$utils.getPng("icon_pay_2_11"),
            key: item.key,
          });
        } else if (item.key == 5 || item.key == 10) {
          this.payData.push({
            name: "支付宝",
            pid: "cycle",
            icon: this.$utils.getPng("icon_pay_23"),
            key: item.key,
          });
        } else if (item.key == 6) {
          this.payData.push({
            pid: "alipay",
            name: "支付宝",
            icon: this.$utils.getPng("icon_pay_23"),
            key: item.key,
          });
        } else if (item.key == 9) {
          this.payData.push({
            pid: "alipay",
            name: "支付宝",
            icon: this.$utils.getPng("icon_pay_23"),
            prompt: "请勿重复扫描支付二维码，以免支付失败",
            key: item.key,
          });
        } else if (item.key == 12) {
          this.payData.push({
            pid: "wxpay",
            name: "微信支付",
            icon: this.$utils.getPng("icon_pay_2_11"),
            key: item.key,
          });
        } else if (item.key == 13) {
          this.payData.push({
            pid: "cardpay",
            name: "银行卡支付",
            icon: this.$utils.getPng("icon_pay_bank"),
            prompt: "请勿重复扫描支付二维码，以免支付失败",
            key: item.key,
          });
        } else if (item.key == 14) {
          this.payData.push({
            pid: "cardpay",
            name: "银行卡支付",
            icon: this.$utils.getPng("icon_pay_bank"),
            prompt: "请勿重复扫描支付二维码，以免支付失败",
            key: item.key,
          });
        }
      });

      if (this.payData?.[0]?.pid == "cycle") {
        this.SelectPid = "cycle";
      } else if (this.payData?.[0]?.pid == "wxpay") {
        this.SelectPid = "wxpay";
      } else if (this.payData?.[0]?.pid == "huabei") {
        this.SelectPid = "huabei";
      } else {
        if (this.SelectPid == "huabei" && type == 1) {
          this.SelectPid = "huabei";
        } else {
          this.SelectPid = "alipay";
        }
      }

      this.resultArray.forEach((item) => {
        if (item.select == 1) {
          this.SelectPid = [
            "alipay",
            "alipay",
            "huabei",
            "wxpay",
            "alipay",
            "cycle",
            "alipay",
            "alipay",
            "alipay",
          ][item.key];
        }
      });
    },
    //勾选协议
    checkArchives() {
      this.isChecked = !this.isChecked;
      // if (this.isout && this.isChecked) {
      //   this.refresh();
      // }
    },
    getBuyList() {
      getBuyListAPI()
        .then((res) => {
          if (res.status == 1) {
            let listArr = res.data.list.map((item) => {
              return { ...item, id: Math.random(0, 1) };
            });
            this.superSlideData = listArr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    useyh() {
      if (this.$utils.getCookie(this.$glb.fmCookieName) == null) {
        this.goLogin();
        return;
      }
      this.showDiscountCode = true;
    },
    onScroll(e) {
      this.scrollButton.left = e.target.scrollLeft > 0;
      this.scrollButton.right =
        e.target.scrollLeft + e.target.clientWidth < e.target.scrollWidth - 20;
    },
    scrollTo(val) {
      this.$refs.scrollBox.scrollTo({ left: val, behavior: "smooth" });
    },
    vipSelect(item, index) {
      if (!this.isPopup) {
        const el = this.$refs.scrollBox.children[index];
        if (el.offsetLeft < this.$refs.scrollBox.scrollLeft) {
          this.scrollTo(0);
        } else if (
          el.offsetLeft + el.clientWidth >
          this.$refs.scrollBox.scrollLeft + this.$refs.scrollBox.clientWidth
        ) {
          this.scrollTo(9999);
        }
      }
      this.vipSelectType = index;
      this.ToolsSelectType = 0;
      this.$refs.DiscountCodeBox.coupeValue = "";
      this.coupndataLast = {};
      this.isUseCoupon = false;
      this.resultArray = [];
      this.pay_id = item.pay_id;
      this.isStatus = 1;
      if (item.coupon != null) {
        this.coupon_id = item.coupon.id;
      } else {
        this.coupon_id = "";
      }
      this.memberInfo.new_pay_list[this.vipSelectType].payment_channel.forEach(
        (item, index) => {
          if (
            item.key != "4" &&
            item.key != "7" &&
            item.key != "8" &&
            item.value == "1"
          ) {
            this.resultArray.push(item); // 添加数字 1
          }
        }
      );
      this.findAmount();
      this.checkCash();
      this.payDataFn();
    },
    vipSelect2(vip_id) {
      if (this.vipSelectType != 0) {
        this.ToolsSelectType = 0;
        this.$refs.DiscountCodeBox.coupeValue = "";
        this.coupndataLast = {};
        this.isUseCoupon = false;
      }
      const foundIndex = this.memberInfo.new_pay_list.findIndex(
        (item) => item.pay_id == vip_id
      );

      // 如果找到，赋值给 this.vipSelectType
      if (foundIndex != -1) {
        this.vipSelectType = foundIndex;
      } else {
        this.vipSelectType = 0; // 默认值（可选）
      }
      this.resultArray = [];
      this.ToolsSelectType = 0;
      this.memberInfo.new_pay_list[this.vipSelectType].payment_channel.forEach(
        (item, index) => {
          if (
            item.key != "4" &&
            item.key != "7" &&
            item.key != "8" &&
            item.value == "1"
          ) {
            this.resultArray.push(item); // 添加数字 1
          }
        }
      );
      if (this.memberInfo.new_pay_list[this.vipSelectType]?.coupon != null) {
        this.coupon_id =
          this.memberInfo.new_pay_list[this.vipSelectType]?.coupon.id;
      } else {
        this.coupon_id = "";
      }
      this.getPcMember({}, 1);
    },
    ToolsSelect(index, item) {
      this.ToolsSelectType = index;
      this.SelectPid = item.pid;
      if (item.pid == "huabei") {
        this.coupndataLast = {};
        this.$refs.DiscountCodeBox.coupeValue = "";
        this.isUseCoupon = false;
        //如如果选中花呗则把coupon_id置为0，清空优惠
        const hasIdZero = this.couponsList.some((item) => item.id === 0);
        if (hasIdZero) {
          this.coupon_id = 0;
        } else {
          this.coupon_id = "";
        }
      } else {
        //反之则给coupon_id赋值优惠券id
        if (!this.isUseCoupon) {
          if (
            this.memberInfo.new_pay_list[this.vipSelectType]?.coupon != null
          ) {
            this.coupon_id =
              this.memberInfo.new_pay_list[this.vipSelectType]?.coupon.id;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
